module.exports = require("@swa-ui/core/src/CaptionPointer/CaptionPointer.module.scss");